import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  buttonsContainer: {
    width: '100%',
    bottom: 10,
    alignItems: 'center',
    position: 'absolute',
  },
  confirmVenueBtn: {
    width: 250,
    height: 50,
    borderRadius: 12,
    marginBottom: 20,
    backgroundColor: '#FFF',
  },
  confirmVenueBtnText: {
    fontSize: 18,
  },
  btnDisabled: {
    backgroundColor: '#FFFFFF66',
  },
  selectLaterBtn: {
    width: 300,
    marginBottom: 20,
    fontSize: 16,
  },
  selectLaterText: {
    fontSize: 16,
    color: '#FFFFFF',
  },
});
